import React from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import { adminSettingStore } from 'state/setting/admin'
import emailNotFound from 'assets/Images/emailnotfoundicon.png'

const MailNotFoundModal: React.FC = () => {
  const {
    mailNotFoundModal,
    setMailNotFoundModal,
    newEmail,
    setNewEmail,
    setAddAdminModal,
    setMailFoundModal,
  } = adminSettingStore(store => ({
    mailNotFoundModal: store.mailNotFoundModal,
    setMailNotFoundModal: store.setMailNotFoundModal,
    newEmail: store.newEmail,
    setNewEmail: store.setNewEmail,
    setAddAdminModal: store.setAddAdminModal,
    setMailFoundModal: store.setMailFoundModal,
  }))

  const handleClose = () => {
    setNewEmail(null)
    setMailNotFoundModal(false)
    setAddAdminModal(true)
  }

  const handleSubmit = () => {
    setMailNotFoundModal(false)
    setMailFoundModal(true)
  }

  return (
    <>
      <CustomModal
        openModal={mailNotFoundModal}
        closeModal={setMailNotFoundModal}
        title=""
        footer={
          <CustomModalFooter
            multibutton={true}
            btnAlignment="justify-center"
            btnText="Try another email, Create new admin"
            closeModal={handleClose}
            onSubmit={handleSubmit}
          />
        }
      >
        <div className="flex align-center justify-center flex-col px-40px ">
          <img src={emailNotFound} alt="email-icon" />
          <h3 className="text-20 w-600 mt-30px">
            Email address is not registered
          </h3>
          <h4 className="text-14 w-500 mt-15px">{newEmail}</h4>
          <p className="text-14 w-400 text-center">
            is not associated with any account. would you like to create new
            account with the provided email address?
          </p>
        </div>
      </CustomModal>
    </>
  )
}

export default MailNotFoundModal
